<template>
  <v-autocomplete
    label="Выберите"
    persistent-hint
    hide-no-data
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    :small-chips="multiple"
    :multiple="multiple"
    :return-object="returnObject"
    :search-input.sync="search"
    :loading="loading"
    :items="items"
  />
</template>

<script>
/**
 * Если передан флаг returnObject тогда возвращаемое значения будет в виде объекта
 * {id: number, code: string, name: string}
 */
export default {
  name: "AutocompleteICD10",

  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      search: null,
      items: [],
    };
  },

  watch: {
    search(val) {
      // Items have already been requested
      if (this.loading) {
        return;
      }

      this.loading = true;

      this.$http("v1/diseases", {
        params: { search: val },
      })
        .then(({ data }) => {
          this.items = data.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
  },

  created() {
    let propValue = [];
    if (Array.isArray(this.$attrs.value)) {
      propValue = this.$attrs.value;
    } else if (this.$attrs.value) {
      propValue = [this.$attrs.value];
    }

    if (propValue.length) {
      this.$http
        .get("v1/diseases/list", {
          params: {
            // Если используется return-object, тогда на вход будет приходить объект, а не числовой Ид
            list: propValue.map(item => (Number.isInteger(item) ? item : item.id)),
          },
        })
        .then(({ data }) => {
          this.items = data.data ?? [];
        });
    }
  },
};
</script>

<style scoped></style>
